<template>
  <div>

    <FieldLabel v-if="prop.show" :label="item.name" :help="showFieldHelp ? fieldHelp : null" :field-id="item.id" :modal-key="modalKey" />
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      transition="scale-transition"
    >
      <!-- Activator : l'icône de modification -->
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on">{{ text }}</v-btn>
      </template>

      <!-- Contenu du menu : le v-card -->
      <v-card width="500">
        <v-card-title>
          Recurrence {{ text }}
        </v-card-title>

        <v-card-text>
            <v-select
            v-model="mode"
            :items="modes"
            item-text="text"
            item-value="value"
            label="Récurrence"
            outlined
            @change="applyPreset"
            ></v-select>
            
            <datePicker
            v-if="freq!=''  && count ==null"
            :valField="moment(until).format('YYYY-MM-DD')"
            :item="{name:'Jusqu\'au',value:'ee',defaultprops:{placeholder:'Choisir ou laisser vide',show:true,iconlr:'prepend',iconinout:'in',iconmdi:'mdi-calendar',clearable:true}}"
            :change="(item,model) => { until = model; applyPreset(mode); }"
            />

          <v-select
            v-if="freq === 'WEEKLY'"
            v-model="byday"
            :items="days"
            chips
            multiple
            label="Jours concernés"
            outlined
            class="mt-3"
            @change="applyPreset(mode)"
          />

          <v-text-field
          v-if="freq!='' && until ==null"
            v-model="count"
            type="number"
            min="1"
            label="Nombre d’occurrences"
            outlined
            class="mt-3"
            clearable
            @input="applyPreset(mode)"
          />
        </v-card-text>
        <v-card-actions>
          
          
          <v-btn text @click="desactiv" class="secondary">désactiver</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="menu = false" class="primary">Appliquer</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

  </div>
</template>

<script>
import mixinFields from '../../mixins/Fields';
import mixinConditionsFields from '../../mixins/conditionsFields';
import datePicker from './datePicker'
export default {
  name: "FieldRecurr",

  mixins: [mixinFields, mixinConditionsFields],
  components : {datePicker},
  data() {
    return {
      dialog: false,

      // état du mode sélectionné
      mode: null,

      // champs pour le RRULE
      freq: "",
      interval: 1,
      byday: [],
      bymonthday : '',
      bymonth : '',
      count: null,
      until: null,
      setpos : null,
      menu: false,

      // options UI
      modes: [
        { text: "desactivé", value: "" },
        { text: "Tous les jours", value: "FREQ=DAILY" },
        { text: "Toutes les semaines", value: "weekly" },
        { text: "Tous les mois à date", value: "monthly" },
        { text: "Tous les mois au meme jour", value: "monthlyevery" },
        { text: "Tous les ans", value: "yearly" },
        { text: "...", value: "custom" }
      ],

      setposs: [
        { text: "tous les premiers du mois", value: "1" },
        { text: "tous les deuxièmes du mois", value: "2" },
        { text: "tous les derniers du mois", value: "-1" },
      ],

      freqs: [
        { text: "Tous les jours", value: "DAILY" },
        { text: "Toutes les semaines", value: "WEEKLY" },
        { text: "Tous les mois", value: "MONTHLY" },
        { text: "Tous les ans", value: "YEARLY" },
      ],

      days: [
        { text: "Lundi", value: "MO" },
        { text: "Mardi", value: "TU" },
        { text: "Mercredi", value: "WE" },
        { text: "Jeudi", value: "TH" },
        { text: "Vendredi", value: "FR" },
        { text: "Samedi", value: "SA" },
        { text: "Dimanche", value: "SU" },
      ],

      rule: "",
      text: "",
      dateStart: null,
    };
  },

  computed: {
    currentForm() {
      return this.$store.getters.listForm(this.modalKey)?.['fields']?.[this.prop.fieldrecurrence];
    },

    showInterval() {
      return this.freq !== "";
    },
    showStepos() {
      return this.freq == "MONTHLY" || this.freq == "YEARLY";
    }
  },

  watch: {
    currentForm(newVal) {

        this.dateStart = newVal;
        console.log('change');
        this.applyPreset(this.mode,true)

    },

    rule(val) {
        this.keyup(this.item,val);
    }
  },

  methods: {

    desactiv() {
      this.freq= ""
      this.interval= 1
      this.byday= []
      this.bymonthday = ''
      this.bymonth = ''
      this.count= null
      this.until= null
      this.setpos = null
      this.menu= false
      this.mode = '';
      this.updateRule();
      
      this.text = this.rruleToText();

    },



    rruleToText(rrule) {
        if (!rrule) return "désactivé";

        const date = new Date(this.dateStart);

        const dayNames = {
            MO: "lundi", TU: "mardi", WE: "mercredi",
            TH: "jeudi", FR: "vendredi", SA: "samedi", SU: "dimanche"
        };

        const monthNames = [
            "janvier","février","mars","avril","mai","juin",
            "juillet","août","septembre","octobre","novembre","décembre"
        ];

        const parts = {};
        rrule.split(";").forEach(p => {
            let [k, v] = p.split("=");
            parts[k] = v;
        });

        let text = "Répétition personnalisée";

        // FREQ = DAILY
        if (parts.FREQ === "DAILY" && !parts.INTERVAL) {
            text = "Tous les jours";
        }
        if (parts.FREQ === "DAILY" && parts.INTERVAL) {
            text = `Tous les ${parts.INTERVAL} jours`;
        }

        // FREQ = WEEKLY
        if (parts.FREQ === "WEEKLY") {
            const days = (parts.BYDAY || "")
                .split(",")
                .map(d => dayNames[d])
                .join(", ");

            if (parts.INTERVAL && parts.INTERVAL !== "1") {
                text = `Toutes les ${parts.INTERVAL} semaines le ${days}`;
            } else {
                text = `Toutes les semaines le ${days}`;
            }
        }

        // FREQ = MONTHLY
        if (parts.FREQ === "MONTHLY") {

            const posMap = { "1": "1er", "2": "2e", "3": "3e", "4": "4e", "-1": "dernier" };

            // Exemple : BYDAY=FR;BYSETPOS=2  →  2e vendredi
            if (parts.BYSETPOS && parts.BYDAY) {
                text = `Tous les mois le ${posMap[parts.BYSETPOS]} ${dayNames[parts.BYDAY]}`;
            } else {
                text = `Tous les mois le ${date.getDate()}`;
            }

            if (parts.INTERVAL && parts.INTERVAL !== "1") {
                text = `Tous les ${parts.INTERVAL} mois le ${date.getDate()}`;
            }
        }

        // FREQ = YEARLY
        if (parts.FREQ === "YEARLY") {
            text = `Tous les ans le ${date.getDate()} ${monthNames[date.getMonth()]}`;

            if (parts.INTERVAL && parts.INTERVAL !== "1") {
                text = `Tous les ${parts.INTERVAL} ans le ${date.getDate()} ${monthNames[date.getMonth()]}`;
            }
        }

        // COUNT
        if (parts.COUNT) {
            text += ` (${parts.COUNT} occurrences)`;
        }

        // UNTIL
        if (parts.UNTIL) {
            const y = parts.UNTIL.slice(0, 4);
            const m = parts.UNTIL.slice(4, 6);
            const d = parts.UNTIL.slice(6, 8);
            text += ` (jusqu’au ${d}/${m}/${y})`;
        }
        if(!parts.COUNT && !parts.UNTIL) {
          text += " sans arrêt";
        }

        return text;
    },

    /** Génère la RRULE personnalisée */
    updateRule() {

      let r = `FREQ=${this.freq}`;

      if (this.interval > 1)
        r += `;INTERVAL=${this.interval}`;

      if (this.byday.length)
        r += `;BYDAY=${this.byday.join(",")}`;

      if (this.bymonthday)
        r += `;BYMONTHDAY=${this.bymonthday}`;

      if (this.count)
        r += `;COUNT=${this.count}`;

      if (this.setpos)
        r += `;BYSETPOS=${this.setpos}`;

      if (this.until)
        r += `;UNTIL=${this.until.replace(/-/g, "")}T235959Z`;


        this.rule = {rule:r,exceptions:[]};
        if(this.freq=='') this.rule = '';


    },

    /** Mode pré-enregistrés type Google */
    applyPreset(mode,ifStatDateChange) {
      const d = new Date(this.dateStart);
      const weekday = ["SU","MO","TU","WE","TH","FR","SA"][d.getDay()];

      //si ladate de début à changé dans le form, et qu'il y a eu une selection de jour, on change pour mettre le nouveau jour de cette nouvelle date
      if(this.byday.length && ifStatDateChange) this.byday= [weekday];
      //si changé aussi, et que on a deja des 1er ou 2 joru du mois
      if(this.setpos && ifStatDateChange) this.setpos = (Math.ceil(d.getDate() / 7)==4)?"-1":Math.ceil(d.getDate() / 7);
      switch (mode) {
        case "FREQ=DAILY":
          this.freq = "DAILY";
          this.setpos = "";
          this.byday = [];
          break;

        case "weekly":
          this.freq = "WEEKLY";

          if(!this.byday.length) this.byday= [weekday];
          break;

        case "monthly":
          this.freq = "MONTHLY";
          this.setpos ='';
          this.bymonthday = d.getDate()
          break;

        case "monthlyevery":
          this.freq = "MONTHLY";
          if(!this.byday.length) this.byday= [weekday];
          var set = Math.ceil(d.getDate() / 7); 
          this.setpos = (set==4)?"-1":set;
          break;

        case "yearly":
          this.freq = "YEARLY";
          this.bymonth = d.getMonth()+1;
          this.bymonthday = d.getDate();
          break;
        
        case "custom":

        break;
        case "":
          this.freq = "";
            this.rule = null;
        break;
      }

      //si il met toutes les semaine, il doit obligatoirement dire quel jour. si le jour est vide, c'est par defaut le jour de la date de début
      if(this.freq=='WEEKLY' && !this.byday.length) this.byday = [weekday];

      this.updateRule()

      this.text = this.rruleToText(this.rule.rule);
      this.mode = 'custom'
      this.modes.find(el => el.value == 'custom').text = this.text;
    },



    //permet de charge les rules qui sont stockés dans la base
  loadFromRule(rrule) {
    if (!rrule) return;


    //on récupère la règle pour enlever le UNTIL afin que mode corresponde bien :
  const parts = rrule.rule.split(";").map(p => p.split("="));
  let sanitarizeRule = [];

  parts.forEach(([key, value]) => {
    if (key!="UNTIL") {
      sanitarizeRule.push(`${key}=${value}`);
    }
    if(key=="UNTIL") this.until = value;
  });

  sanitarizeRule = sanitarizeRule.join(";");


      const d = new Date(this.dateStart);
      const weekday = ["SU","MO","TU","WE","TH","FR","SA"][d.getDay()];

      switch (sanitarizeRule) {
        case "FREQ=DAILY":
          this.mode = "FREQ=DAILY";
          break;

        case `FREQ=WEEKLY;BYDAY=${weekday}`:
          this.mode = "weekly";
          break;

        case `FREQ=MONTHLY;BYMONTHDAY=${d.getDate()}`:
          this.mode = "monthly";
          break;

        case `FREQ=YEARLY;BYMONTH=${d.getMonth()+1};BYMONTHDAY=${d.getDate()}`:
          this.mode = "yearly";
          break;
        
        default:
            this.mode = 'custom';
        break;
      }


    const map = {};
    parts.forEach(([k, v]) => map[k] = v);

    // FREQ
    if (map.FREQ) this.freq = map.FREQ;

    // INTERVAL
    if (map.INTERVAL) {
      this.interval = parseInt(map.INTERVAL, 10);
    }

    // INTERVAL
    if (map.BYSETPOS) {
      this.setpos = parseInt(map.BYSETPOS, 10);
    }
    // BYDAY
    if (map.BYDAY) {
      this.byday = map.BYDAY.split(",");
    }

    // COUNT
    if (map.COUNT) {
      this.count = parseInt(map.COUNT, 10);
    }

    // UNTIL
    if (map.UNTIL) {
      // format Google : 20251130T000000Z → YYYY-MM-DD
      this.until = map.UNTIL.substring(0, 8).replace(
        /(\d{4})(\d{2})(\d{2})/,
        "$1-$2-$3"
      );
    }

    this.rule = rrule;

    this.text = this.rruleToText(rrule.rule);

    this.modes.find(el => el.value == this.mode).text = this.text;
  }


  },


  mounted() {

            this.dateStart = this.replaceBy({
            text: this.$store.getters.listForm(this.modalKey)['fields'][this.prop.fieldrecurrence],
            modalKey: this.modalKey
            });

            this.loadFromRule(this.valField);
  }

  
};
</script>
